import {ApiBase} from "@/src/model/ApiBase";
import {DATA_API_TYPE} from "@/src/model/apiTypes";

export class DataApi extends ApiBase {
    async [DATA_API_TYPE.GET_DATAPOOLS]() {
        return await this.httpGet('datapools/')
    }

    async [DATA_API_TYPE.GET_DATAMODELS]({datapoolId}) {
        return await this.httpGet(`datapools/${datapoolId}/datamodels/`)
    }

    async [DATA_API_TYPE.GET_ACTIVITIES]({graphId}) {
        return await this.httpPost(`activities`, {graphId})
    }

    async [DATA_API_TYPE.GET_FABRIC_CONNECTION_STRING]({workspaceId, sqlEndpointId, itemId}) {
        return await this.httpPost('fabric/connection-string', {
            workspaceId,
            sqlEndpointId,
            itemId,
        })
    }

    async [DATA_API_TYPE.GET_FABRIC_TABLES]({workspaceId, sqlEndpointId, itemId}) {
        return await this.httpPost('fabric/tables', {workspaceId, sqlEndpointId, itemId})
    }

    async [DATA_API_TYPE.GET_FABRIC_COLUMNS]({workspaceId, sqlEndpointId, itemId, schema, table}) {
        return await this.httpPost('fabric/columns', {workspaceId, sqlEndpointId, itemId, schema, table})
    }

    async [DATA_API_TYPE.GET_TABLES]({datapoolId, datamodelId}) {
        return await this.httpGet(`datapools/${datapoolId}/datamodels/${datamodelId}/tables/`)
    }

    async [DATA_API_TYPE.GET_TABLE_COLUMNS]({datapoolId, datamodelId, tableId}) {
        return await this.httpGet(`datapools/${datapoolId}/datamodels/${datamodelId}/tables/${tableId}/columns/`)
    }

    async [DATA_API_TYPE.GET_CASE_TABLES]({datapoolId, datamodelId}) {
        return await this.httpGet(`datapools/${datapoolId}/datamodels/${datamodelId}/case-tables/`)
    }

    async [DATA_API_TYPE.VALIDATE_PQL]({datapoolId, datamodelId, pql}) {
        return await this.httpPost(`datapools/${datapoolId}/datamodels/${datamodelId}/pql-validation/`, {pql})
    }

    async [DATA_API_TYPE.RELOAD_DATAMODEL]({datapoolId, datamodelId, leadingObjectTable}) {
        return await this.httpGet(`datapools/${datapoolId}/datamodels/${datamodelId}/reload/${leadingObjectTable}/`)
    }

    async [DATA_API_TYPE.PAC_GRAMMAR]({testString}) {
        return await this.httpPost(`pac-grammar/`, {test_string: testString})
    }

     async [DATA_API_TYPE.GET_GRAPH_TABLE_OPTIONS]({datapoolId, datamodelId}) {
        return await this.httpGet(`datapools/${datapoolId}/datamodels/${datamodelId}/activity-tables/`)
    }

    async [DATA_API_TYPE.TEMPLATES]() {
        return await this.httpGet('templates/')
    }
}

